import React from 'react';
import { Container, Form, InputGroup, Label, Row } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import cx from 'classnames';

// ducks
import { typeahead_assisted_living } from '../../ducks/Shared';

// components
import TypeAhead from '../../components/form/field/typeahead';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';

let SearchForm = props => {
  const { handleSubmit } = props;

  return (
    <Row className={cx(styles.searchHeader, BS.pt3)}>
      <Container>
        <Form inline className={`${BS.alignItemsStart}`} onSubmit={handleSubmit}>
          <InputGroup className={cx(BS.inputGroupGutter, BS.pb2)}>
            <Label for="name" className="sr-only">
              Name
            </Label>
            <Field
              name="name"
              type="text"
              placeholder="Name"
              component={TypeAhead}
              labelAsValue
              loadOptions={(search, callback) =>
                typeahead_assisted_living(search, callback)
              }
              showSubmit
              submitClassName={cx(BS.ml2)}
            />
          </InputGroup>
        </Form>
      </Container>
    </Row>
  );
};

const AssistedLivingSearchForm = reduxForm({
  form: 'assisted-living-search-form'
})(SearchForm);

export default AssistedLivingSearchForm;



// WEBPACK FOOTER //
// ./src/containers/AssistedLivingSearch/AssistedLivingSearchForm.js